import { useTranslation } from 'react-i18next';
import Select from 'components/Inputs/Select';
import Switch from 'components/Kizen/Switch';
import { useGetFieldOptions } from 'hooks/useChangeField';
import { useCallback } from 'react';
import Loader from 'components/Kizen/Loader';
import { DraggableExportColumns } from './DraggableExportColumns';
import { Wrapper } from './styles';
import { SwitchControl } from 'pages/QuickFiltersPage/styles';
import Cols from '__components/Layout/Cols';

const fieldOptionFilter = () => true;

const ChooseColumnsToExport = ({
  selectedOption,
  setSelectedOption,
  includeKizenId,
  setIncludeKizenId,
  summarizeRelationships,
  setSummarizeRelationships,
  selectedFields,
  setSelectedFields,
  model,
}) => {
  const { t } = useTranslation();
  const options = [
    { value: 'all', label: t('All Columns') },
    { value: 'visible', label: t('Visible Columns on Table') },
    { value: 'custom', label: t('Select Columns') },
  ];

  const { options: fieldOptions, loadingOptions } = useGetFieldOptions({
    customObjectId: model.id,
    fieldOptionFilter,
  });

  const handleChangeColumns = useCallback(
    (slected) => {
      setSelectedFields(slected.map(({ id, label }) => ({ label, value: id })));
    },
    [setSelectedFields]
  );

  return (
    <Wrapper>
      <Select
        fullWidth
        menuInline
        label={t('Choose Columns to Export')}
        options={options}
        value={selectedOption || options[0]}
        onChange={setSelectedOption}
        placeholder={t('Visible Columns on Table')}
        margin
      />
      <Cols columns={4} gutter="10px">
        <SwitchControl label={t('Include Kizen ID Column')}>
          <Switch
            removeMargin
            checked={includeKizenId}
            onChange={(e) => setIncludeKizenId(e.target.checked)}
            textPlacement="left"
          />
        </SwitchControl>
        <SwitchControl label={t('Summarize Large Relationships')}>
          <Switch
            removeMargin
            checked={summarizeRelationships}
            onChange={(e) => setSummarizeRelationships(e.target.checked)}
            textPlacement="left"
          />
        </SwitchControl>
      </Cols>
      {selectedOption?.value === 'custom' ? (
        <Loader loading={loadingOptions} paddingTop={20}>
          <DraggableExportColumns
            selectedFields={selectedFields}
            fieldOptions={fieldOptions}
            onChange={handleChangeColumns}
          />
        </Loader>
      ) : null}
    </Wrapper>
  );
};
export default ChooseColumnsToExport;
